export const freeTrialPilotDeepLinkQrCode = "/pilot_deep_link_qr_code";
